import SectionEmpezar from "../components/SectionEmpezar/SectionEmpezar";

const Empezar = () => {
  return <SectionEmpezar />;
};

export default Empezar;
